<template>
  <div v-if="isVisible" class="date-override-container" :class="{ 'collapsed': isCollapsed }">
    <div class="header" @click="toggleCollapse">
      <i class="pi" :class="isCollapsed ? 'pi-calendar' : 'pi-times'"></i>
    </div>
    <div v-if="!isCollapsed" class="content">
      <div class="date-info">
      <h3>Esto solo es para pruebas</h3>
        <div>
          <label>Fecha modificada:</label>
          <span>{{ formattedOverrideDate }}</span>
        </div>
      </div>
      <div class="controls">
        <VueDatePicker 
          v-if="isDatePickerReady"
          v-model="selectedDate" 
          :enable-time-picker="true" 
          :is-24="true"
          time-picker-inline
          auto-apply
          @closed="handleDatePickerClosed"
          @update:model-value="handleDateUpdate"
          locale="es-MX"   format="dd/MM/yyyy"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import CustomButton from '../components/ui/CustomButton.vue';

export default {
  components: {
    VueDatePicker,
    CustomButton
  },
  data() {
    return {
      isCollapsed: true,
      selectedDate: null,
      isVisible: false,
      isDatePickerReady: false
    };
  },
  computed: {
    formattedCurrentDate() {
      return this.formatDate(new Date());
    },
    formattedOverrideDate() {
      return this.selectedDate ? this.formatDate(this.selectedDate) : 'No modificada';
    }
  },
  created() {
    // Verificar si estamos en entorno de pruebas o desarrollo
    const hostname = window.location.hostname;
    this.isVisible = hostname === 'localhost' || 
                    hostname.includes('webapp.beta-lm.com') || 
                    window.location.href.includes('localhost:8081');
  },
  mounted() {
    // Inicializar con la fecha actual como valor predeterminado
    this.selectedDate = new Date();
    
    // Recuperar fecha guardada si existe
    const savedDate = localStorage.getItem('overrideDate');
    if (savedDate) {
      try {
        const parsedDate = new Date(savedDate);
        
        // Verificar que la fecha sea válida
        if (!isNaN(parsedDate.getTime())) {
          this.selectedDate = parsedDate;
          this.$emit('date-changed', this.selectedDate);
        } else {
          
          localStorage.removeItem('overrideDate');
        }
      } catch (error) {
        
        localStorage.removeItem('overrideDate');
      }
    }
    
    // Establecer isDatePickerReady a true para evitar renderizado con valores inválidos
    this.$nextTick(() => {
      this.isDatePickerReady = true;
    });
  },
  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    handleDateUpdate(newDate) {
      // Validar la fecha antes de actualizarla
      if (newDate && !isNaN(new Date(newDate).getTime())) {
        this.selectedDate = newDate;
        
      } else {
        
      }
    },
    handleDatePickerClosed() {
      // Solo aplicar cuando se cierra el selector
      this.applyDate();
    },
    applyDate() {
      try {
        if (this.selectedDate && !isNaN(this.selectedDate.getTime())) {
          // Guardar en localStorage y emitir evento
          const isoDate = this.selectedDate.toISOString();

          // Usar try/catch separados para cada operación para una mejor recuperación de errores
          try {
            localStorage.setItem('overrideDate', isoDate);
            
          } catch (storageError) {

            try {
              // Intentar usando sessionStorage como alternativa
              sessionStorage.setItem('overrideDate', isoDate);
              
            } catch (sessionError) {
              
            }
          }
          
          // Emitir el evento con la fecha modificada
          try {
            this.$emit('date-changed', new Date(this.selectedDate));
            
            this.$toast.add({
              severity: 'success', 
              summary: 'Fecha modificada', 
              detail: `Fecha cambiada a: ${this.formatDate(this.selectedDate)}`,
              life: 3000
            });
          } catch (emitError) {
            
          }
        } else {
          
          this.resetDate();
        }
      } catch (error) {
        
        this.resetDate();
      }
    },
    resetDate() {
      try {
        this.selectedDate = new Date();
        
        try {
          localStorage.removeItem('overrideDate');
          
        } catch (storageError) {
          
          // Intentar limpiar sessionStorage si estamos usándolo
          sessionStorage.removeItem('overrideDate');
        }
        
        this.$emit('date-changed', null);
        
        this.$toast.add({
          severity: 'info', 
          summary: 'Fecha restablecida', 
          detail: 'Se usará la fecha actual del sistema',
          life: 3000
        });
      } catch (error) {
        
      }
    },
    formatDate(date) {
      if (!date || isNaN(date.getTime())) {
        return 'Fecha inválida';
      }
      
      try {
        return date.toLocaleDateString('es-MX', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch (error) {
        
        return 'Error de formato';
      }
    }
  }
}
</script>

<style scoped>
.date-override-container {
  position: fixed;
  top: 10px;
  right: 10px;
  width: 320px;
  background-color: var(--background-color);
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 9999;
  transition: all 0.3s ease;
  border: 1px solid var(--primary-color);
}

.header {
  padding: 8px 12px;
  background-color: var(--primary-color);
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.collapsed .header {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  position: fixed;
  top: 10px;
  right: 10px;
}

.header i {
  font-size: 1.2rem;
}

.content {
  padding: 12px;
}

.date-info {
  margin-bottom: 12px;
  font-size: 0.9em;
}

.date-info div {
  margin-bottom: 8px;
}

.date-info label {
  font-weight: bold;
  margin-right: 8px;
}

.controls {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.collapsed {
  width: auto;
  background: transparent;
  border: none;
  box-shadow: none;
}
</style>
